import { render, staticRenderFns } from "./PageLayoutEight.vue?vue&type=template&id=288db938&scoped=true&"
import script from "./PageLayoutEight.vue?vue&type=script&lang=js&"
export * from "./PageLayoutEight.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutEight.vue?vue&type=style&index=0&id=288db938&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288db938",
  null
  
)

export default component.exports